export const fingerPrintRandomKey = Math.random() + 'fp';

class Fp123asd {
  static generate() {
    return window[fingerPrintRandomKey];
  }
}

export default Fp123asd;
